import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        // 基本
        background: '#BD8D05',
        font_main: '#fff',
        // メイン見出し
        headline_second: '#fff',
        // ヘッダー
        header_bg: '#BD8D05',
        header_font: '#fff',
        // フッター
        footer_bg: '#191818',
        footer_link: '#fff',
        // ボタン
        btn_main_bg: '#CCD316',
        btn_main_font: '#0F0F0F',
        btn_main_gradation_first: '#1e77d6',
        btn_main_gradation_second: '#06ecfc',
        // 文字サイズ変更ボタン
        change_btn: '#bd8d07',
        change_btn_invert: '#CCD316',
        // テキストリンク
        link_main: '#3131D0',
        link_sub: '#F7FF39',
        // 鑑定師一覧・詳細
        actor_box_bg: '#F5EEDA',
        actor_box_font: '#000',
        actor_box_border: '#C4AB65',
        // メールBOX一覧・鑑定ポイント一覧
        menu_list: '#F5EEDA',
        menu_list_font: '#212020',
        // メールBOX見出し
        mail_box_headline: '#212020',
        mail_box_headline_font: '#fff',
        // 通知バッジ
        badge: '#CC0909',
        badge_font: '#fff',
        // ポイント表
        table_head: '#21202',
        table_head_font: '#fff',
        table_body: '#F5EEDA',
        table_body_font: '#212020',
        // 無料占い結果
        horo_result_bg: '#f4f0eb',
        horo_result_gradation_first: '#F8FD00',
        horo_result_gradation_second: '#F2D000',
        horo_result_border: '#BF4545',
        horo_result_font: '#000',
        // 強調・注意部分
        emphasis: '#BE1528',
        caution: '#BE1528',
        font_annotation: '#fff',
        // その他テキスト
        error: '#ff4500',
        info: '#72bc88',
        success: '#29fa2d',
        // 固定ページ
        page_headline: '#f9fc1e',
        page_link: '#f9fc1e'
      }
    },
    options: { customProperties: true }
  }
})
